/* eslint-disable no-alert */
/* eslint-disable react-native/no-inline-styles */
import {Button, Card, Icon, Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {Image, Linking, Platform, StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import {getImage} from '../../../../../helpers/general';
import {
  getSubjectNameById,
  isLandscape,
  px,
  safeText,
  wp,
} from '../../../../../utils';

const NotesIcon = (props) => (
  <Icon {...props} fill="#FF5722" name="book-open-outline" />
);

const JoinClassIcon = (props) => (
  <Icon {...props} fill="#FF5722" name="video-outline" />
);

const WatchIcon = (props) => (
  <Icon {...props} fill="#FF5722" name="play-circle-outline" />
);

const CustomCard = ({data}) => {
  const {
    subjectId,
    weekDay,
    startTime,
    endTime,
    classLink,
    videoLink,
    fileLink,
    teacherName,
    teacherImage,
    scheduleCanceledId,
    scheduleCancelReason,
  } = data;
  const subjects = useSelector((state) => state.general.subjects);

  const handlePress = async (url) => {
    if (Platform.OS === 'web') {
      window.open(url, '_blank');
    } else {
      const supported = await Linking.canOpenURL(url);
      if (supported) {
        await Linking.openURL(url);
      } else {
        alert(`Don't know how to open this URL: ${url}`);
      }
    }
  };

  const isClassCanceled = !!scheduleCanceledId;

  return (
    <Card
      disabled={isClassCanceled}
      style={[
        styles.container,
        isClassCanceled && {backgroundColor: '#F5F5F5'},
      ]}>
      <Text
        style={[
          styles.leftColText,
          {fontWeight: '600'},
          isClassCanceled && {opacity: 0.5},
        ]}>
        {`${getSubjectNameById({
          id: subjectId,
          subjects,
        })}`}
      </Text>
      <Layout style={[styles.body, isClassCanceled && {opacity: 0.5}]}>
        <Layout style={styles.leftCol}>
          <Text style={[styles.leftColText, {marginTop: 7}]} appearance="hint">
            {safeText(weekDay)}
          </Text>
          <Text style={[styles.leftColText, {marginTop: 6}]} appearance="hint">
            {startTime + ' - ' + endTime}
          </Text>

          <Button
            disabled={!(classLink && !videoLink) || isClassCanceled}
            size="small"
            style={[styles.button, {marginTop: 18}]}
            appearance="ghost"
            status="warning"
            accessoryLeft={JoinClassIcon}
            onPress={() => handlePress(classLink)}>
            {(evaProps) => (
              <Text {...evaProps} style={[evaProps.style]}>
                {'Join Classroom'}
              </Text>
            )}
          </Button>

          <Button
            disabled={isClassCanceled || !fileLink}
            size="small"
            style={styles.button}
            appearance="ghost"
            status="warning"
            accessoryLeft={NotesIcon}
            onPress={() => handlePress(fileLink)}>
            {(evaProps) => (
              <Text {...evaProps} style={[evaProps.style]}>
                {'View Notes'}
              </Text>
            )}
          </Button>

          <Button
            disabled={!videoLink || isClassCanceled}
            size="small"
            style={styles.button}
            appearance="ghost"
            status="warning"
            accessoryLeft={WatchIcon}
            onPress={() => handlePress(videoLink)}>
            {(evaProps) => (
              <Text {...evaProps} style={[evaProps.style]}>
                {'Watch Recording'}
              </Text>
            )}
          </Button>
        </Layout>
        <Layout style={styles.rightCol} level="1">
          <Image
            source={{uri: getImage(teacherImage)}}
            resizeMode="contain"
            style={styles.personIcon}
          />
          <Text numberOfLines={2} style={styles.personName}>
            {teacherName}
          </Text>
        </Layout>
      </Layout>

      {isClassCanceled && (
        <View>
          <Text style={styles.cancelText}>{scheduleCancelReason}</Text>
        </View>
      )}
    </Card>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignSelf: 'center',
    height: 'auto',
    paddingTop: px(12),
    paddingBottom: px(19),
    paddingHorizontal: px(3),
    marginBottom: px(17),
    marginRight: 5,
    borderColor: '#C2CFE0',
  },
  body: {
    flexDirection: 'row',
    width: '100%',
    height: 'auto',
    backgroundColor: 'transparent',
  },
  leftCol: {
    flex: 1.5,
    backgroundColor: 'transparent',
  },
  rightCol: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 1,
    paddingBottom: px(10),
    backgroundColor: 'transparent',
  },
  studentName: {
    fontSize: px(20),
    marginTop: px(5),
    paddingHorizontal: px(12),
  },
  leftColText: {
    marginLeft: px(12),
  },
  button: {
    color: '#FF5722',
    fontSize: px(14),
    justifyContent: 'flex-start',
    marginHorizontal: px(5),
    paddingHorizontal: 0,
    paddingVertical: 0,
    marginBottom: px(3),
  },
  personIcon: {
    width: isLandscape() ? wp(6) : px(96),
    height: isLandscape() ? wp(6) : px(96),
    borderRadius: 50,
    backgroundColor: '#FFEDEF',
  },
  personName: {
    marginTop: px(5),
    textAlign: 'center',
  },
  cancelText: {
    padding: 10,
    fontSize: 14,
    fontWeight: 'bold',
  },
});

export default CustomCard;
